import React from 'react'
import ScreenCyclesTable from '../../../../components/ScreenCyclesTable/ScreenCyclesTable';
import CycleStatus from '../../../../enums/cycle-status.enum';
import { CompletedCycleContractItemProps } from './interfaces/CompletedCycleContractItemProps';
import { useTranslation } from 'react-i18next';
import { useCompletedCycleContract } from './hooks/useCompletedCycleContract';
import Modal from '../../../../components/Modal/Modal';
import CycleAttachment from '../../../../components/CycleAttachment/CycleAttachment';
import CycleSettings from '../../../../components/CycleSettings/CycleSettings';
import DuplicateCycleModal from '../../../../components/DuplicateCycleModal/DuplicateCycleModal';

const CompletedLocationContractCyclesItem: React.FC<CompletedCycleContractItemProps> = ({ cycles, contractId, contractName }) => {
  const {
    cycleActions,

    //cycle settings
    cycleIdSettings,
    cycleNameSettings,
    openSelectedCycleSettings,
    closeSelectedCycleSettings,

    //delete cycle from screen
    cycleIdDelete,
    closeSelectedCycleDelete,
    onAcceptSelectedCycleDelete,

    //attach to cycle
    cycleIdAttach,
    closeSelectedCycleAttach,
    onAcceptSelectedCycleAttach,
    onSelectFile,
    isSaveAttachment,

    //multi-duplicate cycle
    cycleIdDuplicate,
    cycleNameDuplicate,
    closeSelectedCycleDuplicate,
    onCycleDuplicated,
  } = useCompletedCycleContract(contractId);
  const { t } = useTranslation();

  const contractTitle = `${t('labels.contractName')}: ${contractName}`;

  return (
    <>
      <li className="c-completed-location-contract-cycles-item flex flex-col relative overflow-hidden rounded-lg border border-foggy-mist bg-white p-2 shadow-15 dark:border-strokedark dark:bg-boxdark">
        <span className="c-screen__name text-base font-bold max-md:pb-1 md:text-xl">{contractTitle}</span>
        {!!cycles.length && (
          <ScreenCyclesTable
            openSettings={openSelectedCycleSettings}
            screenCycles={cycles}
            actionsButtons={cycleActions}
            status={CycleStatus.Completed}
          />
        )}
      </li>
      <Modal
        modalTitle={t('labels.cycleDeletion')}
        isVisible={!!cycleIdDelete}
        content="Are you sure you want to delete this cycle?"
        acceptBtnText="Delete"
        onClose={closeSelectedCycleDelete}
        onAccept={onAcceptSelectedCycleDelete}
        showAcceptBtn
        showCancelBtn
      />

      <Modal
        modalTitle={t('labels.cycleAttachments')}
        isVisible={!!cycleIdAttach}
        onClose={closeSelectedCycleAttach}
        onAccept={onAcceptSelectedCycleAttach}
        acceptBtnText={`${isSaveAttachment ? 'Saving...' : 'Save'}`}
        className="min-h-[500px] w-[800px]"
      >
        <CycleAttachment onSelectFile={onSelectFile} />
      </Modal>

      {
        !!cycleIdSettings && (
          <CycleSettings isVisible={!!cycleIdSettings} onClose={closeSelectedCycleSettings} cycleId={cycleIdSettings} cycleName={cycleNameSettings} />
        )
      }

      <DuplicateCycleModal
        cycleId={cycleIdDuplicate}
        cycleName={cycleNameDuplicate}
        isVisible={!!cycleIdDuplicate}
        onClose={closeSelectedCycleDuplicate}
        onDuplicated={onCycleDuplicated}
      />
    </>
  )
};

export default CompletedLocationContractCyclesItem;